module.exports = __webpack_public_path__ + "static/img/esquema.0214b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/esquema-en/esquema.png
// module id = +BjY
// module chunks = 0